import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentImage} from '@tisa-group/models';
import {ImageVariantModule} from '@tisa-group/core';

@Component({
  selector: 'tisa-image-client',
  imports: [CommonModule, ImageVariantModule],
  templateUrl: './image-client.component.html',
  styleUrl: './image-client.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageClientComponent {
  readonly component = input<UmpireComponentImage | undefined>();
}
